<template>
  <div>
    <cui-check-email class=" mb-3 mt-5 pt-3" />
  </div>
</template>
<script>
import CuiCheckEmail from '@/components/cleanui/system/Auth/CheckEmail'
export default {
  components: {
    CuiCheckEmail,
  },
}
</script>
